import { render, staticRenderFns } from "./AvgFarmerLineList.vue?vue&type=template&id=6821a980"
import script from "./AvgFarmerLineList.vue?vue&type=script&lang=js"
export * from "./AvgFarmerLineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports